import BaseListPresenter from "../../../../base/BaseListPresenter";

class NewsListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  async onClickDeleteItem(index) {
    const object = this.objects[index];
    const collection = this.view.getCollectionName();
    try {
      await this.view.showDialog({
        title: "Delete Data?",
        message: "Are you sure you want to delete?",
      });
      await this.deleteObjectUseCase.execute(collection, object.id);
      const index = this.objects.indexOf(object);
      this.objects.splice(index, 1);
      this.view.setObjects(this.objects);
      this.view.setSelected([]);
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}

export default NewsListPresenter;
